/* Loupe – mobile dock (sections/mobile-dock.liquid).
   Adds body.has-mobile-dock (the section's CSS pads the page and offsets the toast / compare tray on phones),
   keeps the cart count in sync with theme.js ("loupe:cart-updated") and optionally hides on scroll down. */
(() => {
  if (customElements.get('loupe-mobile-dock')) return;

  class LoupeMobileDock extends HTMLElement {
    connectedCallback() {
      const body = document.body;
      body.classList.add('has-mobile-dock');
      body.classList.toggle('has-mobile-dock--compact', this.classList.contains('mobile-dock--compact'));
      this.countEl = this.querySelector('[data-dock-count]');
      this.cartEl = this.querySelector('[data-dock-cart]');

      this.onCart = () => this.syncCount();
      this.onShow = (e) => { if (e.persisted) this.fetchCount(); };   // back/forward cache: the cart may have changed
      document.addEventListener('loupe:cart-updated', this.onCart);
      addEventListener('pageshow', this.onShow);

      if (this.dataset.hideOnScroll === 'true') {
        let last = scrollY, ticking = false;
        this.onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            if (body.classList.contains('is-locked')) return;   // a drawer is open
            const y = Math.max(0, scrollY), d = y - last;
            const atEnd = innerHeight + y >= document.documentElement.scrollHeight - 8;
            if (y < 80 || atEnd) { this.hide(false); last = y; return; }   // always visible at the top and the very end
            if (Math.abs(d) < 8) return;
            this.hide(d > 0); last = y;
          });
        };
        addEventListener('scroll', this.onScroll, { passive: true });
        this.onFocus = () => this.hide(false);
        this.addEventListener('focusin', this.onFocus);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('loupe:cart-updated', this.onCart);
      removeEventListener('pageshow', this.onShow);
      if (this.onScroll) removeEventListener('scroll', this.onScroll);
      if (this.onFocus) this.removeEventListener('focusin', this.onFocus);
      document.body.classList.remove('has-mobile-dock', 'has-mobile-dock--compact', 'mobile-dock-hidden');
    }

    hide(on) {
      if (on === !!this.isHidden) return;
      this.isHidden = on;
      this.classList.toggle('is-hidden', on);
      document.body.classList.toggle('mobile-dock-hidden', on);
    }

    /* theme.js re-renders the header bubble before it dispatches loupe:cart-updated – read it from there */
    syncCount() {
      const src = [...document.querySelectorAll('[data-cart-section="cart-count"]')].find((el) => !this.contains(el));
      if (!src) return this.fetchCount();
      const b = src.querySelector('.cart-count');
      this.setCount(b ? parseInt(b.textContent, 10) || 0 : 0);
    }

    async fetchCount() {
      try {
        const base = (window.Loupe && window.Loupe.routes && window.Loupe.routes.cart) || '/cart';
        const r = await fetch(`${base}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (r.ok) this.setCount((await r.json()).item_count || 0);
      } catch (e) {}
    }

    setCount(n) {
      if (!this.countEl) return;
      this.countEl.textContent = n;
      this.countEl.hidden = !n;
      if (!this.cartEl) return;
      const label = this.dataset.cartLabel || '';
      const items = n === 1 ? this.dataset.countOne : (this.dataset.countOther || '').replace('99999', n);
      this.cartEl.setAttribute('aria-label', n && items ? `${label} (${items})` : label);
    }
  }

  customElements.define('loupe-mobile-dock', LoupeMobileDock);
})();
